"use strict";

(function () {
  'use strict';

  angular.module('lr.Auth').service('authInterceptor', ['$rootScope', '$q', '$window', 'authEvents', function ($rootScope, $q, $window, authEvents) {
    var proxy = this;

    proxy.request = function (config) {
      config.headers = config.headers || {};

      if ($window.sessionStorage.token) {
        config.headers.Authorization = $window.sessionStorage.token;
      }

      return config;
    };

    proxy.responseError = function (response) {
      if (response.status === 401 || response.status === 403) {
        // handle the case where the user is not authenticated
        $rootScope.$broadcast(authEvents.login);
      }

      return response;
    };
  }]);
})();